/* eslint-disable camelcase */

// packages
import React from 'reactn'
import $ from 'jquery'

// atoms
import { Container, NavigationItem } from '../../atoms'

/**
 * Class representing the navigation.
 *
 * @class Navigation
 * @hideconstructor
 * @author Lexus Drumgold <lex@lexusdrumgold.design>
 */
export default class Navigation extends React.Component {
  state = { menu_open: false }

  close_navigation = () => {
    $('.adm-navigation').removeClass('open')
    $('#app > .ado-footer').removeClass('hide')
  }

  /**
   * Renders the navigation.
   *
   * @returns {HTMLElement} html nav element
   */
  render = () => {
    const { items } = this.props

    return (
      <nav className='adm-navigation'>
        <Container>
          <div className='links'>
            {
              items.map(item => {
                return (
                  <NavigationItem
                    path={item.path}
                    text={item.path.replace('/', '').toUpperCase()}
                  />
                )
              })
            }
          </div>
        </Container>
      </nav>
    )
  }
}
